<template>
  <div>
    <div
      ref="chartRef"
      style="width: 100%; height: 400px;"
    />
  </div>
</template>

<script setup>
import * as echarts from 'echarts'
import { onMounted, onUnmounted, ref, watch } from 'vue'

// Props for dynamic chart data and title
const props = defineProps({
  chartData: {
    type: Array,
    required: true, // Expects an array of objects { name: 'Category', value: 123 }
  },
  chartTitle: {
    type: String,
    default: '', // Default chart title
  },
})

const chartRef = ref(null)
let chartInstance = null

const initChart = () => {
  if (chartInstance) {
    chartInstance.dispose() // Clean up old instance
  }

  const chartDom = chartRef.value
  if (chartDom) {
    chartInstance = echarts.init(chartDom)

    const option = {
      title: {
        text: props.chartTitle,
        left: 'center',
        top: '5%',
      },
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          const formattedValue = Number(params.value).toLocaleString('en-US') // Add commas to the number
          
          return `${params.seriesName} <br/>${params.name}: ${formattedValue} (${params.percent}%)`
        },
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'middle',
        data: Array.isArray(props.chartData) ? props.chartData.map(item => item.name) : [],
      },
      series: [
        {
          name: props.chartTitle, 
          type: 'pie',
          radius: '50%',
          data: props.chartData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    }


    chartInstance.setOption(option)

    // Make the chart responsive
    window.addEventListener('resize', chartInstance.resize)
  }
}

onMounted(initChart)

onUnmounted(() => {
  if (chartInstance) {
    window.removeEventListener('resize', chartInstance.resize)
    chartInstance.dispose()
  }
})

// Reinitialize chart when data or title changes
watch(() => [props.chartData, props.chartCategories], initChart, { immediate: true })
</script>

<style scoped>
#chartRef {
  width: 100%;
  height: 400px;
}
</style>
